import React, { useState } from "react";
import { TextInput, Button } from "../indexComponents";

function CreateTeamForm({ onTeamAdded, close }) {
  const [teamName, setTeamName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const generateRandomCode = async () => {
    let code = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      code += characters[randomIndex];
    }
    return code;
  };

  const createTeam = async () => {
    if (teamName.length < 4) {
      setErrorMessage("Le nom d'équipe doit être 4 caractère ou plus");
      setTimeout(() => {
        setErrorMessage("");
      }, 2500);
      return;
    }
    const TeamCode = await generateRandomCode();

    const response = await fetch(`${process.env.REACT_APP_API_URL}/team`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        name: teamName,
        team_code: TeamCode,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to create team");
    }

    setTeamName("");
    onTeamAdded();
    close();
  };
  return (
    <div className="CreateTeamForm">
      <form>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        <TextInput
          labelText="Nom de l'équipe"
          name="team_name"
          type="text"
          placeholder=""
          value={teamName}
          onChange={(e) => setTeamName(e.target.value)}
        />
        <div className="btn-container">
          <Button
            className="create-team-btn"
            onClick={createTeam}
            text="Créer"
          />
          <Button onClick={close} text="Fermer" />
        </div>
      </form>
    </div>
  );
}

export default CreateTeamForm;
